import React, { createContext, useContext, useState } from 'react';
import Cookies from 'js-cookie';
import {post_auth, isProduction} from './auth'
import { isEmpty } from 'lodash';
import { useAuth } from './AuthProvider';

// const serverUrl = 'http://127.0.0.1:8000'; // using gunicorn in container
// const serverUrl = 'http://127.0.0.1:5500'; // using local flask
// const serverUrl = 'http://127.0.0.1:80'; // using nginx (not working as of 2024-04-07)
// const serverUrl = 'https://127.0.0.1:8443';
// const serverUrl = 'https://192.168.1.219:8443';
// const serverUrl = 'https://llserver-een4z6k6ba-uc.a.run.app'

const getServerUrl = () => {
    // const serverUrl = process.env.NODE_ENV === 'production'
    const serverUrl = isProduction()
        ? 'https://llserver-een4z6k6ba-uc.a.run.app'
        : 'http://127.0.0.1:5500'; // using local flask

    return serverUrl;
    // return 'https://llserver-een4z6k6ba-uc.a.run.app'
}



// const getServerUrl = () => {
//     const serverUrl = 'https://llserver-een4z6k6ba-uc.a.run.app';

//     return serverUrl;
// }

const serverUrl = getServerUrl();
const configName = 'LearnLanguagesMBDNS';
const routeManageConfig = '/manage_config';

const ConfigContext = createContext();
export const useConfig = () => useContext(ConfigContext);

const langCodes = [
{ value: 'en-US', label: 'English US', flag: '🇺🇸', native: 'English (US)', },
{ value: 'en-GB', label: 'English GB', flag: '🇬🇧', native: 'English (GB)' },
{ value: 'it-IT', label: 'Italian',    flag: '🇮🇹', native: 'Italiano' },
{ value: 'es-ES', label: 'Spanish',    flag: '🇪🇸', native: 'Español' },
{ value: 'fr-FR', label: 'French',     flag: '🇫🇷', native: 'Français' },
{ value: 'de-DE', label: 'German',     flag: '🇩🇪', native: 'Deutsch' },
{ value: 'ru-RU', label: 'Russian',    flag: '🇷🇺', native: 'Русский' },
{ value: 'el-GR', label: 'Greek',      flag: '🇬🇷', native: 'Ελληνικά' },
{ value: 'ja-JP', label: 'Japanese',   flag: '🇯🇵', native: '日本語' },
{ value: 'cmn-CN', label: 'Chinese (M)', flag: '🇨🇳', native: '中文' },
{ value: 'pt-PT', label: 'Portuguese', flag: '🇵🇹', native: 'Português' },
{ value: 'he-IL', label: 'Hebrew',     flag: '🇮🇱', native: 'עברית' },
{ value: 'fi-FI', label: 'Finnish',    flag: '🇫🇮', native: 'Suomi' },
{ value: 'ko-KR', label: 'Korean',     flag: '🇰🇷', native: '한국어' },
{ value: 'sv-SE', label: 'Swedish',    flag: '🇸🇪', native: 'Svenska' },
];
  

// These keys to the confuration objects are put here to facilitate export to other modules
const configKeys = {langLearn:'langCodes/Learn',
                    langBase: 'langCodes/Base',
                    genderKey:'genderKey',
                    currentContent:'currentContent',
             };

function findByLabel(label) {
    return langCodes.find(item => item.label === label);
}             

// Default config. Used to fill uninitialize keys in the stored config.
const defaultConfig = {
    [configKeys.langLearn]: langCodes[2],
    [configKeys.langBase]: langCodes[0],
    [configKeys.genderKey]: 'female',
    [configKeys.currentContent]:'100+',
    'firstTime': {'mainPage':true},
};

// Shared constants
export const MONTHLY_PAYMENT = 5.0;



export const ConfigProvider = ({ children }) => {
    // const {isAuthenticated } = useAuth();
    // const [config, setConfig] = useState(defaultConfig);
    const [config, setConfig] = useState({});
    const { logout } = useAuth();
    // const [loading, setLoading] = useState(true);
    // const [loading, setLoading] = useState(false);
 
    const getConfigCloud = async () => {
        // if (!isAuthenticated()) {
        //     return null;
        // }
    
        try {
            const uri = `${serverUrl}${routeManageConfig}`;
            const data = { 'command': 'get' };
            const response = await post_auth(uri, data, logout);
            console.log('Get Config Cloud Response:', response);
            let conf = response.data.config;
            if (isEmpty(conf)) {
               conf = defaultConfig;
            }
            if (! (configKeys.currentContent in conf)){
                conf[configKeys.currentContent] =  defaultConfig[configKeys.currentContent]
            }
            setConfig({...conf});
            console.log('config from cloud:', conf);
            return conf;
        // } catch (error) {
        //     console.error('Error getting config from cloud:', error);
        //     setDefaultConfig();

        //     return defaultConfig;
        // }
    } catch (error) {
        console.error('Error getting config from cloud:', error);
        throw error;
        // setDefaultConfig();

        // return defaultConfig;
    }
    };
        
    const getConfigCookies = () => {
        const storedConfig = Cookies.get(configName);
        if (storedConfig && storedConfig.length > 0) {
            setConfig(JSON.parse(storedConfig));
            return true;
        } else {
            return false;
        }
    }
    
    const saveConfigCloud = async (conf) => {
        // if (!isAuthenticated()) {
        //     return null;
        // }
    
        try {
            const uri = `${serverUrl}${routeManageConfig}`;
            const data = { 'command': 'save', 'config': conf };
            const response = await post_auth(uri, data, logout);
            console.log('Save Config Cloud Response:', response);
            return response.data;
        } catch (error) {
            console.error('Error saving config to cloud:', error);
            throw error;
            // return null;
        }
    };    


    const setDefaultConfig = () => {
        setConfig(defaultConfig);
    }

    const updateConfig = async (key, value) => {
        const newConfig = { ...config, [key]: value };
        if ( ! isEmpty(newConfig)) {
            await saveConfig(newConfig);
            setConfig(newConfig);
            
        };
    };


    const deleteConfig = () => {
        Cookies.remove(configName);
    };

    const saveConfig = async (aconfig) => {
        // const strConfig = JSON.stringify(aconfig);
        // Cookies.set(configName, strConfig, { sameSite: 'None', secure: true });   
        if (! isEmpty(aconfig)) {
            await saveConfigCloud(aconfig);
            console.log('save config', aconfig) 
        }
    };

    return (
        <ConfigContext.Provider value={{ config, updateConfig, deleteConfig, saveConfig, setDefaultConfig, getConfigCloud, getConfigCookies }}>
            {children}
        </ConfigContext.Provider>
    );
};

export {serverUrl, getServerUrl, findByLabel, langCodes, configKeys}